import { BaseService } from "./BaseService";

export const ProcessamentoService = {
    async store(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('processamento', postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a criação do processamento:', error);
            return false;
        }
    },
    async scheduled(type = 'tabelas-basicas') {
        try {
            return await BaseService.fetchResponseFromAPIGet(`processamento/scheduled/${type}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca do processamentos:', error);
            return false;
        }
    }, 
    async retry(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost(`processamento/retry`, postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a tentativa de reprocessar:', error);
            return false;
        }
    }, 
    async destroy(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('processamento/destroy', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao excluir processamento:', error);
            return false;
        }
    }
}